import { TChoiceOption } from '~/types/table';

export const mapChoiceOptionToText = (choice?: TChoiceOption) => choice?.text;
